import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { FaClasses, toggleVisible } from "@cervval.js/client-html5-core/src/tools/css.tools";
import { FLEX_CONTAINER_COLUMN, FLEX_ITEM, H_100, PADDING, W_100 } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { CustomElement, NAVIGATION_SERVICE, NavigationService, WebPageComponent } from "@cervval.js/client-html5-spa/navigation";
import { ButtonStyle } from "@cervval.js/client-html5-ui/src/components/button/button";
import { CjsDialog, DialogFooterButton, DialogPosition, DialogSize, showErrorInDialog } from "@cervval.js/client-html5-ui/src/components/dialog/dialog";
import { CjsGeneratedForm } from "@cervval.js/client-html5-ui/src/components/generatedForm/generatedForm";
import { GeneratedFormEditMode, GeneratedFormSaveMode } from "@cervval.js/client-html5-ui/src/components/generatedForm/generatedForm.types";
import { CjsIconFa } from "@cervval.js/client-html5-ui/src/components/icon/iconFa";
import { IconFaSize } from "@cervval.js/client-html5-ui/src/components/icon/iconFa.tools";
import { CjsFileListEditor, FileWithLink } from "@cervval.js/client-html5-ui/src/editors/fileListEditor/fileListEditor";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { DataModel } from "@cervval.js/common/src/forms/dataModel";
import { translateHTMLReferences } from "@ehealth_tools/client-html-tools/src/tools/webcomponent.tools";
import { BookingCommonUser } from "@ehealth_tools/common-booking/src/data/booking.dto";
import { isProfessional } from "@ehealth_tools/common-booking/src/data/booking.tools";
import { exportBookingMailDTOToPropertyConfig } from "@ehealth_tools/common-booking/src/data/bookingUser/mailBooking.propertyConfig";
import { exportBookingPhoneNumberDTOToPropertyConfig } from "@ehealth_tools/common-booking/src/data/bookingUser/phoneBooking.propertyConfig";
import { exportBookingUserDTOToPropertyConfig } from "@ehealth_tools/common-booking/src/data/bookingUser/profileBooking.propertyConfig";
import { BOOKING_SERVICE } from "@ehealth_tools/common-booking/src/services/abstractCommonBooking.service";
import { formatUserName } from "@ehealth_tools/common/src/data/user/user.tools";
import { AbstractClientBookingService } from "../../../services/abstractClientBooking.service";
import { BookingPageName } from "../../booking.pages";
import { I18nProfile } from "./profilePage.i18n";
@CustomElement({
    name: "profile-page",
    style: require("./profilePage.scss"),
    template: require("./profilePage.html"),
    i18n: require("./profilePage.i18n").I18n(),
    elementCssClasses: [W_100, H_100, FLEX_CONTAINER_COLUMN, FLEX_ITEM, PADDING.PY_2]
})
export class Profile<I18n extends I18nProfile = I18nProfile> extends WebPageComponent<I18n> {
    @TypedHtmlElements({ ensureLoadedClasses: [CjsIconFa] })
    public readonly components!: {
        container: HTMLDivElement,
        titlePage: HTMLDivElement,
        identityTitle: HTMLDivElement,
        iconProfile: CjsIconFa,
        myProfileTitle: HTMLDivElement,
        profileName: HTMLDivElement,
        changeProfileIcon: CjsIconFa,
        iconRelation: CjsIconFa,
        myRelationsTitle: HTMLDivElement,
        relations: HTMLDivElement,
        changeRelationIcon: CjsIconFa,
        iconPro: CjsIconFa,
        myProTitle: HTMLDivElement,
        pro: HTMLDivElement,
        changeProIcon: CjsIconFa,
        connectionTitle: HTMLDivElement,
        iconPhoneNumber: CjsIconFa,
        myPhoneNumberTitle: HTMLDivElement,
        phoneNumber: HTMLDivElement,
        changePhoneNumberIcon: CjsIconFa,
        iconMail: CjsIconFa,
        myMailTitle: HTMLDivElement,
        mail: HTMLDivElement,
        changeMailIcon: CjsIconFa,
        proDiv: HTMLDivElement,
        // My Company
        companyDiv: HTMLDivElement,
        changeCompanyIcon: CjsIconFa,
        iconCompany: CjsIconFa,
        myCompanyTitle: HTMLDivElement,
        companyDescription: HTMLDivElement,
        // My Calendar
        calendarDiv: HTMLDivElement,
        iconCalendar: CjsIconFa,
        myCalendarTitle: HTMLDivElement,
        calendarDescription: HTMLDivElement,
        changeCalendarIcon: CjsIconFa
    };

    @Injected(NAVIGATION_SERVICE)
    private readonly navigationService!: NavigationService<BookingPageName>;

    @Injected(BOOKING_SERVICE)
    private _bookingService!: AbstractClientBookingService;

    /**
     * Current user
     */
    private _currentUser: BookingCommonUser | undefined;

    /**
     * GeneratedForm, displayed in a dialog to edit a BookingUser
     */
    private _profileForm: CjsGeneratedForm<BookingCommonUser> = new CjsGeneratedForm();
    /**
     * GeneratedForm, displayed in a dialog to edit a BookingUser
     */
    private _mailForm: CjsGeneratedForm<BookingCommonUser> = new CjsGeneratedForm();
    /**
     * GeneratedForm, displayed in a dialog to edit a BookingUser
     */
    private _phoneNumberForm: CjsGeneratedForm<BookingCommonUser> = new CjsGeneratedForm();
    /**
     * DataModel object for _noteForm
     */
    private _profileDataModel: DataModel<BookingCommonUser> = new DataModel();

    private _tmpImgFile: string = "";
    private _imageFile: CjsFileListEditor = new CjsFileListEditor();


    /** @inheritdoc */
    public override init(): void {
        this._initIcons();
    }

    /**
     * Init icons
     */
    private _initIcons(): void {
        // Profile
        this.components.iconProfile.options.setAndRefreshIfChanged({
            name: "fa-user",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["primary-color"]
        });
        this.components.changeProfileIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-right",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["grey-color"]
        });
        this.components.changeProfileIcon.clickEvent.on(() => {
            this._buildDialogForProfile();
        });

        // Relations Client-Client
        this.components.iconRelation.options.setAndRefreshIfChanged({
            name: "fa-users",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["primary-color"]
        });
        this.components.changeRelationIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-right",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["grey-color"]
        });
        this.components.changeRelationIcon.clickEvent.on(() => {
            this.navigationService.navigate("relation");
        });

        // Relation Client-Pro
        this.components.iconPro.options.setAndRefreshIfChanged({
            name: "fa-users-medical",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["primary-color"]
        });
        this.components.changeProIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-right",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["grey-color"]
        });
        this.components.changeProIcon.clickEvent.on(() => {
            this.navigationService.navigate("professional");
        });

        // Phone number
        this.components.iconPhoneNumber.options.setAndRefreshIfChanged({
            name: "fa-phone",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["primary-color"]
        });
        this.components.changePhoneNumberIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-right",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["grey-color"]
        });
        this.components.changePhoneNumberIcon.clickEvent.on(() => {
            this._buildDialogForPhoneNumber();
        });

        // Mail
        this.components.iconMail.options.setAndRefreshIfChanged({
            name: "fa-at",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["primary-color"]
        });
        this.components.changeMailIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-right",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["grey-color"]
        });
        this.components.changeMailIcon.clickEvent.on(() => {
            this._buildDialogForMail();
        });

        // Company
        this.components.iconCompany.options.setAndRefreshIfChanged({
            name: "fa-buildings",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["primary-color"]
        });
        this.components.changeCompanyIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-right",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["grey-color"]
        });
        this.components.changeCompanyIcon.clickEvent.on(() => {
            // FIXME TODO
        });

        // Calendar
        this.components.iconCalendar.options.setAndRefreshIfChanged({
            name: "fa-clock",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["primary-color"]
        });
        this.components.changeCalendarIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-right",
            size: IconFaSize.X1,
            prefix: FaClasses.SOLID,
            classes: ["grey-color"]
        });
        this.components.changeCalendarIcon.clickEvent.on(() => {
            this.navigationService.navigate("calendar");
        });
    }

    /** @inheritdoc */
    public override refresh(): void {
        this._currentUser = this._bookingService.getCurrentUser();
        this._refreshI18n();

        toggleVisible(this.components.proDiv, !isProfessional(this._currentUser));
        toggleVisible(this.components.companyDiv, isProfessional(this._currentUser));
    }

    /**
     * Refresh i18n elements
     */
    private _refreshI18n(): void {
        translateHTMLReferences(this.components, this.i18n.html);

        if (this._currentUser != null) {
            this.components.profileName.innerText = formatUserName(this._currentUser);
            this.components.phoneNumber.innerText = this._currentUser.phoneNumber ?? "";
            this.components.mail.innerText = this._currentUser.email ?? "";
        }
    }


    /** Build a dialog for viewing, editing User profile */
    private _buildDialogForProfile(): void {
        const footerButtons: DialogFooterButton[] = [];
        if (this._currentUser != null) {
            this._profileDataModel.setData([this._currentUser]);
        }
        this._profileForm.options.setWithoutRefresh({
            formMode: { saveMode: GeneratedFormSaveMode.STATIC, editMode: GeneratedFormEditMode.UPDATE }
        });
        this._profileForm.initialize(exportBookingUserDTOToPropertyConfig(), this._profileDataModel, this._profileDataModel.getDataCopy());

        footerButtons.push({
            button: { label: this.i18n.profileDialog.save, cssClasses: ["btn-save"] }, action: "confirm",
            callback: async () => {
                try {
                    const saveResult = this._profileForm.save();
                    const newValues = saveResult.elementsToUpdate;
                    if (newValues && this._currentUser) {
                        const partialObject: Partial<BookingCommonUser> = {};
                        for (const newValue of newValues) {
                            partialObject[newValue.propertyName] = newValue.value;
                        }
                        await this._bookingService.updateValues(this._bookingService.tables.bookingUsers, this._currentUser, partialObject);
                    }
                    _dialog.hide();
                    this.refresh();
                    // }
                } catch (err) {
                    showErrorInDialog(err);
                }
            }
        });

        footerButtons.push({
            button: {
                label: this.i18n.profileDialog.cancel,
                cssStyle: ButtonStyle.SECONDARY
            },
            action: "close",
            callback: () => _dialog.hide()
        });

        const _dialog: CjsDialog = new CjsDialog({
            title: this.i18n.profileDialog.title,
            position: DialogPosition.CENTER,
            size: DialogSize.LARGE,
            footerButtons: footerButtons,
            enableDraggable: false,
            enableDismiss: true
        });

        _dialog.addToBody(this._profileForm);

        // GSN : Section commented because there is no profile icon displayed on the application yet, even on the map
        // this._imageFile.options.setAndRefreshIfChanged({
        //     onNewFileAdded: this._onImageUploaded.bind(this)
        // });

        // this._imageFile.filePickerOptions.setAndRefreshIfChanged({
        //     ...defaultFilePickerOptions,
        //     accepts: [".png", ".jpeg", ".jpg"],
        //     pickerTitle: this.i18n.profilePicture,
        //     enableMultiple: false
        // });

        // this._imageFile.classList.add("pt-3");

        // _dialog.addToBody(this._imageFile);
    }

    /**
     * Callback used when an image has been uploaded.
     * Change the image preview based on uploaded image
     * @param file File object uploaded
     */
    private _onImageUploaded(file: FileWithLink): Promise<FileWithLink> {

        this._tmpImgFile = URL.createObjectURL(this._imageFile.filePicker.getFiles()[0]);

        return Promise.resolve(file);
    }

    /** Build a dialog for viewing, editing User profile */
    private _buildDialogForMail(): void {

        let dialogTitle = "";
        const footerButtons: DialogFooterButton[] = [];
        if (this._currentUser != null) {
            this._profileDataModel.setData([this._currentUser]);
        }
        this._mailForm.options.setWithoutRefresh({
            formMode: { saveMode: GeneratedFormSaveMode.STATIC, editMode: GeneratedFormEditMode.UPDATE }
        });
        this._mailForm.initialize(exportBookingMailDTOToPropertyConfig(), this._profileDataModel, this._profileDataModel.getDataCopy());
        dialogTitle = "Modifier mon adresse mail";
        footerButtons.push({
            button: { label: "enregistrer", cssClasses: ["btn-save"] }, action: "confirm",
            callback: () => {
                try {
                    // TODO persistence
                    // const saveResult = await this._saveNote();
                    // if (saveResult) {
                    _dialog.hide();
                    this.refresh();
                    // }
                } catch (err) {
                    showErrorInDialog(err);
                }
            }
        });

        footerButtons.push({
            button: {
                label: "femer",
                cssStyle: ButtonStyle.SECONDARY
            },
            action: "close",
            callback: () => _dialog.hide()
        });

        const _dialog: CjsDialog = new CjsDialog({
            title: dialogTitle,
            position: DialogPosition.CENTER,
            size: DialogSize.LARGE,
            footerButtons: footerButtons,
            enableDraggable: false,
            enableDismiss: true
        });

        _dialog.addToBody(this._mailForm);
    }

    /** Build a dialog for viewing, editing User profile */
    private _buildDialogForPhoneNumber(): void {

        const footerButtons: DialogFooterButton[] = [];
        if (this._currentUser != null) {
            this._profileDataModel.setData([this._currentUser]);
        }
        this._phoneNumberForm.options.setWithoutRefresh({
            formMode: { saveMode: GeneratedFormSaveMode.STATIC, editMode: GeneratedFormEditMode.UPDATE }
        });
        this._phoneNumberForm.initialize(exportBookingPhoneNumberDTOToPropertyConfig(), this._profileDataModel, this._profileDataModel.getDataCopy());
        footerButtons.push({
            button: { label: this.i18n.phoneNumberDialog.save, cssClasses: ["btn-save"] }, action: "confirm",
            callback: async () => {
                try {
                    const saveResult = this._phoneNumberForm.save();
                    const newValues = saveResult.elementsToUpdate;
                    if (newValues && this._currentUser) {
                        const partialObject: Partial<BookingCommonUser> = {};
                        for (const newValue of newValues) {
                            partialObject[newValue.propertyName] = newValue.value;
                        }
                        await this._bookingService.updateValues(this._bookingService.tables.bookingUsers, this._currentUser, partialObject);
                    }
                    _dialog.hide();
                    this.refresh();
                    // }
                } catch (err) {
                    showErrorInDialog(err);
                }
            }
        });

        footerButtons.push({
            button: {
                label: this.i18n.phoneNumberDialog.cancel,
                cssStyle: ButtonStyle.SECONDARY
            },
            action: "close",
            callback: () => _dialog.hide()
        });

        const _dialog: CjsDialog = new CjsDialog({
            title: this.i18n.phoneNumberDialog.title,
            position: DialogPosition.CENTER,
            size: DialogSize.LARGE,
            footerButtons: footerButtons,
            enableDraggable: false,
            enableDismiss: true
        });

        _dialog.addToBody(this._phoneNumberForm);
    }


}
